var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.94869 3.89739C3.02437 3.89739 3.89739 3.02437 3.89739 1.94869C3.89739 0.873015 3.02437 0 1.94869 0C0.873015 0 0 0.873015 0 1.94869C0 3.02437 0.873015 3.89739 1.94869 3.89739ZM0 16.8889V5.19668H3.89739V16.8889H0ZM6.49632 5.19668H10.091V7.03885H10.143C10.6431 6.14116 11.8669 5.19668 13.6922 5.19668C17.487 5.19668 18.1885 7.5585 18.1885 10.6309V16.8889H14.4404V11.3415C14.4404 10.019 14.4132 8.31589 12.4918 8.31589C10.5405 8.31589 10.2417 9.75662 10.2417 11.2455V16.8889H6.49632V5.19668Z",
    fill: "#484848"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcIn);
export default __webpack_public_path__ + "static/media/ic_in.40f470c4.svg";
export { ForwardRef as ReactComponent };